import React from 'react'
import {
    DATE_FORMAT,
    STATUS_CANCELLED,
    STATUS_DENIED,
    STATUS_APPROVED,
    STATUS_SAVED,
    STATUS_REJECTED,
    PARTICIPANT_STATUS_PENDING,
    PARTICIPANT_STATUS_PRESENT,
    PARTICIPANT_STATUS_ABSENT,
} from './constants';
import moment from 'moment';

export const formatAmount = (amount) => {
    let fAmount = amount;
    if (!fAmount) {
        fAmount = 0;
    }
    let cleanAmount = fAmount.toString().replaceAll(/,/g, '');
    if (!isNumeric(cleanAmount)) {
        cleanAmount = 0;
    }
    return Number(parseFloat(cleanAmount).toFixed(2)).toLocaleString('en', {
        minimumFractionDigits: 2
    });
}

export const parseAmount = amount => {
    let cleanAmount = amount.toString().replaceAll(/,/g, '');
    if (!isNumeric(cleanAmount)) {
        cleanAmount = 0;
    }
    return parseFloat(cleanAmount);
}

export const formatDate = (date, format = DATE_FORMAT) => {
    return moment(date).format(format);
}

export const formatDatetime = (date) => {
    return moment(date, 'YYYYMMDDhhmmss').format('MM/DD/YYYY hh:mm:ss');
}

export const convertToUTC = (dateStr) => {
    return moment.utc(dateStr).format();
}

export const isNumeric = (n) => {
    return !isNaN(parseFloat(n));
}

export const convertDTStringToDate = (datetimestr) => {
    if (!isNumeric(datetimestr)) {
        return 'Invalid Date';
    }

    return datetimestr.trim().replaceAll(/^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/g, '$1-$2-$3 $4:$5:$6');
}

export const convertDateStringToDate = (datetimestr) => {
    if (!isNumeric(datetimestr)) {
        return 'Invalid Date';
    }

    return datetimestr.trim().replaceAll(/^(\d{4})(\d{2})(\d{2})$/g, '$1-$2-$3');
}

/**
 * Get an Object's specific property value in an array of objects
 * @param  {Array} arrObj [description]
 * @param  {int or str} value  [description]
 * @param  {string} property    [description]
 * @return {mutiple}        [description]
 */
export const getDropdownLabel = (arrObj, value, byProp = 'value', retProp = 'name') => {
    let found = arrObj.find(obj => !isNaN(value) ? obj[byProp] == value : obj[retProp] == value);
    return found ? found[retProp] : '';
}

export const formatApprovalStatus = (status) => {
    let statusClass = 'label-warning'
    let statusLabel = 'Pending'
    switch (status.toString().toUpperCase()) {
        case STATUS_CANCELLED:
        case '19':
            statusClass = 'label-default'
            statusLabel = 'Cancelled'
            break
        case STATUS_DENIED:
        case STATUS_REJECTED:
        case '21':
            statusClass = 'label-danger'
            statusLabel = 'Rejected'
            break
        case STATUS_APPROVED:
        case '18':
            statusClass = 'label-success'
            statusLabel = 'Approved'
            break
        case STATUS_SAVED:
        case '22':
            statusClass = 'label-primary'
            statusLabel = 'Saved'
            break
        default:
            statusClass = 'label-warning'
            statusLabel = 'Pending'
            break
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatInterviewSchedule = (date) => {
    return moment(date).format('MM/DD/YYYY HH:mm');
}

export const formatApplicationStatus = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    switch (status) {
        case 'On-hold':
            statusClass = 'label-warning'
            break
        case 'Rejected/Failed':
        case 'Not Confirmed':
            statusClass = 'label-danger'
            break
        case 'Shortlisted':
        case 'For Screening':
        case 'Undergoing Background Check':
        case 'Undergoing Job Offer':
        case 'Employed':
            statusClass = 'label-primary'
            break
        case 'For Preliminary Interview':
        case 'For Technical Interview':
        case 'For Final Interview':
            statusClass = 'label-default'
            break
        case 'Confirmed':
        case 'Onboarding':
        case 'Deployed':
        case 'Accepted':
            statusClass = 'label-success'
            break
        default:
            statusClass = 'label-warning'
            break
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatInterviewApplicationStatus = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    switch (status) {
        case 'For Preliminary Interview':
            statusClass = 'label-primary'
            break
        case 'For Technical Interview':
            statusClass = 'label-default'
            break
        case 'For Final Interview':
            statusClass = 'label-success'
            break
        default:
            statusClass = 'label-warning'
            break
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatInterviewResults = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    switch (status) {
        case 'Failed':
            statusClass = 'label-danger'
            break
        case 'Pending':
            statusClass = 'label-warning'
            break
        case 'Passed':
            statusClass = 'label-success'
            break
        default:
            statusClass = 'label-warning'
            break

    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatJobOfferStatus = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    let isCorrectStatus = false;
    switch (status) {
        case 'Declined':
            isCorrectStatus = true;
            statusClass = 'label-danger'
            break
        case 'Rejected/Failed':
            isCorrectStatus = true;
            statusClass = 'label-danger'
            break
        case 'Pending':
            isCorrectStatus = true;
            statusClass = 'label-warning'
            break
        case 'Accepted':
        case 'Approved':
            isCorrectStatus = true;
            statusClass = 'label-success'
            break
        case 'For Approval':
            isCorrectStatus = true;
            statusClass = 'label-primary'
            break
        default:
            statusClass = 'label-default'
            break

    }
    statusClass = `label ${statusClass}`
    return (
        isCorrectStatus === false ? status : <span className={statusClass}>{statusLabel.toUpperCase()}</span>
    );
}

export const formatTrainingAttendanceStatus = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    let isCorrectStatus = false;
    switch (status) {
        case 'Pending':
            isCorrectStatus = true;
            statusClass = 'label-warning'
            break
        case 'Absent':
            isCorrectStatus = true;
            statusClass = 'label-danger'
            break
        case 'Present':
            isCorrectStatus = true;
            statusClass = 'label-success'
            break
        default:
            statusClass = 'label-default'
            break

    }
    statusClass = `label ${statusClass}`
    return (
        isCorrectStatus === false ? status : <span className={statusClass}>{statusLabel.toUpperCase()}</span>
    );
}


export const formatStatusDetails = (status, mode, cell) => {
    let statusClass = 'label-danger';
    switch (status) {
        case 'On-hold':
            statusClass = 'label-default'
            statusClass = `label ${statusClass}`
            return <span className={statusClass}>Application On-hold</span>
            break
        case 'Rejected/Failed':
            statusClass = 'label-danger'
            statusClass = `label ${statusClass}`
            return <span className={statusClass}>{cell}</span>
        case 'For Preliminary Interview':
        case 'For Technical Interview':
        case 'For Final Interview':
            let onlineInterview = 10
            if (mode === onlineInterview) {
                return <a href={cell} target="_blank">{cell}</a>
            } else {
                return cell === null ? null : cell
            }
        case 'Accepted':
            statusClass = 'label-success'
            statusClass = `label ${statusClass}`
            return <span className={statusClass}>{cell}</span>
        default:
            return cell === null ? null : cell
    }
}

export const formatBackgroundCheck = (status) => {
    let statusClass = 'label-warning'
    let statusLabel = 'Pending'
    switch (status.toString().toUpperCase()) {
        case STATUS_CANCELLED:
        case '19':
            statusClass = 'label-success'
            statusLabel = 'Responded: Complete'
            break
        case '20':
            statusClass = 'label-danger'
            statusLabel = 'Responded: Incomplete'
            break
        case '21':
            statusClass = 'label-warning'
            statusLabel = 'Pending'
            break
        case '22':
            statusClass = 'label-primary'
            statusLabel = 'Survey Email Sent'
            break
        case '8':
            statusClass = 'label-primary'
            statusLabel = 'Undergoing Background Check'
            break
        case '16':
            statusClass = 'label-success'
            statusLabel = 'Pass'
            break
        case '18':
            statusClass = 'label-danger'
            statusLabel = 'Fail'
            break
        case '2':
            statusClass = 'label-danger'
            statusLabel = 'Rejected/Failed'
            break
        default:
            statusClass = 'label-success'
            statusLabel = 'Completed Background Check'
            break
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatBackgroundCheckSurvey = (status) => {
    let statusClass = 'label-warning'
    let statusLabel = 'Pending'
    switch (status.toString().toUpperCase()) {
        case STATUS_CANCELLED:
        case '19':
            statusClass = 'label-success'
            statusLabel = 'Responded: Complete'
            break
        case '20':
            statusClass = 'label-danger'
            statusLabel = 'Responded: Incomplete'
            break
        case '21':
            statusClass = 'label-warning'
            statusLabel = 'Resend Survey'
            break
        case '22':
            statusClass = 'label-primary'
            statusLabel = 'Survey Email Sent'
            break
        case '18':
            statusClass = 'label-danger'
            statusLabel = 'Invalid Email'
            break
        default:
            statusClass = 'label-success'
            statusLabel = 'Completed Background Check'
            break
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatParticipantAttendance = (attendance) => {
    let statusClass = '';
    let statusLabel = ' ';

    if (attendance === null) {
        statusClass = '';
        statusLabel = ' ';
    } else if (attendance === true) {
        statusClass = 'label-success';
        statusLabel = 'PRESENT';
    } else if (attendance === false) {
        statusClass = 'label-danger';
        statusLabel = 'ABSENT';
    }

    statusClass = `label ${statusClass}`;
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
};

export const formatOnboardingTrackerStatus = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    switch (status) {
        case 'Incomplete':
            statusClass = 'label-warning'
            break
        case 'Complete':
            statusClass = 'label-success'
            break
        default:
            statusClass = 'label-warning'
            break

    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatTrainingTrackerDetailsStatus = (attendanceStatus) => {
    let statusClass = 'label-danger';
    let statusLabel = attendanceStatus;
    if (attendanceStatus === true) {
        statusClass = "label-success";
        statusLabel = PARTICIPANT_STATUS_PRESENT;
    } else if (attendanceStatus === false) {
        statusClass = "label-danger";
        statusLabel = PARTICIPANT_STATUS_ABSENT;
    } else {
        statusClass = "label-warning";
        statusLabel = PARTICIPANT_STATUS_PENDING;
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
};

export const formatTrainingStatus = (status) => {
    let statusClass = 'label-danger';
    let statusLabel = status;
    switch (status) {
        case 'Done':
            statusClass = 'label-success'
            break
        case 'Ongoing':
            statusClass = 'label-warning'
            break
        default:
            statusClass = 'label-default'
            break
    }
    statusClass = `label ${statusClass}`
    return (
        <span className={statusClass}>{statusLabel}</span>
    );
}

export const formatApproverStatus = () => {
    let statusClass = 'label-default';
    let statusLabel = 'No Approver Assigned';

    statusClass = `label ${statusClass}`
    return <span className={statusClass}>{statusLabel}</span>
}
